import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import MultipleGoogleMediaUpload from '../../GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'
import ImageAssetPreview from '../../GoogleAssetsSliderPreview/Previews/ImageAssetPreview'

import { lightGrey } from '../../../../../styles/const/colors'

import { FILE_URL, SQUARE_LOGO, squareLogoHeight, squareLogoWidth } from '../../fields'
import { squareLogoValidationSchema } from '../../validations'

import useCommonStyles from '../../../../../styles/common/stepForms'
import useStyles from './styles'

const stepFields = [SQUARE_LOGO]

function SquareLogoStep({ formik, handleStepChange, isStepFieldsValid }) {
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const { t } = useTranslation()

  const { values } = formik

  const fileUrl = values[SQUARE_LOGO][0]?.[FILE_URL]

  const handleContinue = () => {
    handleStepChange(stepFields, values)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Upload at least 1 square logo')}</div>
      <div className={commonClasses.stepBody}>
        <div className={classes.squareLogo}>
          <ImageAssetPreview
            containerWidth={260}
            width={squareLogoWidth}
            height={squareLogoHeight}
            fileUrl={fileUrl}
            backgroundColor={'white'}
            arrowColor={lightGrey}
          />
        </div>
        <MultipleGoogleMediaUpload
          formik={formik}
          FileItemPath={SQUARE_LOGO}
          validationSchema={squareLogoValidationSchema}
          isStepFieldsValid={isStepFieldsValid}
          addAnotherButtonText={'Add another square logo'}
          width={squareLogoWidth}
          height={squareLogoHeight}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default SquareLogoStep
